module.exports = __webpack_public_path__ + "img/newbie-map-maker.e04007f8.svg";